export default {
    user: state => state.user,
    assignations: state => state.assignations,
    checklistAnswers: state => state.checklistAnswers,
    client: state => state.client,
    config: state => state.config,
    currentPoint: state => state.currentPoint,
    currentRound: state => state.currentRound,
    drawer: state => state.drawer,
    inProgress: state => state.inProgress,
    lastAnnotations: state => state.lastAnnotations,
    lastRound: state => state.lastRound,
    lastRounds: state => state.lastRounds,
    venue: state => state.venue,
    rounds: state => state.rounds,
    roundInProgress: state => state.roundInProgress,
    openRounds: state => state.openRounds,
    updateAvailable: state => state.updateAvailable
};
